// "Proposals & quotes" on the project and lead rails (workflow D1). No
// separate mockup: the rows reuse Tools & delivery's rail-artifact-row
// pattern, and "+ Log sent" opens the same form the Stats band uses,
// prefilled with this record's link and client.

import { WonProjectAction } from './WonProjectAction';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { DOCUMENT_SEND_OUTCOME_LABELS, type DocumentSendListItem } from '../../shared/types';
import { amountOf, kindLabel, OUTCOME_TONE, sendOpenTarget, useDocumentSends } from '../lib/documentSends';
import { DocumentSendForm, type DocumentSendDefaults } from './DocumentSendForm';
import { Pill } from './primitives';

export function DocumentSendsRail({
  filter,
  defaults,
}: {
  filter: { lead_id: string } | { project_id: string };
  defaults: Partial<DocumentSendDefaults>;
}) {
  const sends = useDocumentSends(filter);
  // `null` = closed; `{ send: null }` = a fresh Log sent.
  const [form, setForm] = useState<{ send: DocumentSendListItem | null } | null>(null);

  return (
    <>
      {sends !== null && sends.length === 0 && <div className="field-value dim">Nothing sent yet.</div>}
      {(sends ?? []).map((s) => {
        const target = sendOpenTarget(s);
        return (
          <div key={s.id} style={{ marginTop: 4 }}>
            <div className="rail-artifact-row" style={{ marginTop: 0 }}>
              <span className="field-label" style={{ margin: 0, flexShrink: 0 }}>
                {kindLabel(s)}
              </span>
              <span
                className="field-value field-value-clamp2"
                role="button"
                tabIndex={0}
                title={s.title}
                style={{ cursor: 'pointer' }}
                onClick={() => setForm({ send: s })}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setForm({ send: s });
                  }
                }}
              >
                {s.title}
              </span>
            </div>
            {/* The rail is ~260px: status, amount and Open sit on their own
                line so the title keeps the width it needs. */}
            <div className="rail-artifact-row" style={{ marginTop: 3, alignItems: 'center' }}>
              <Pill tone={OUTCOME_TONE[s.outcome]}>{DOCUMENT_SEND_OUTCOME_LABELS[s.outcome]}</Pill>
              <span className="row-meta gold">{amountOf(s)}</span>
              {target &&
                ('internal' in target ? (
                  <Link to={target.internal} style={{ color: 'var(--accent)', flexShrink: 0, marginLeft: 'auto' }}>
                    Open ↗
                  </Link>
                ) : (
                  <a
                    href={target.external}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: 'var(--accent)', flexShrink: 0, marginLeft: 'auto' }}
                  >
                    Open ↗
                  </a>
                ))}
            </div>
            <WonProjectAction send={s}/>
          </div>
        );
      })}
      <div style={{ marginTop: 2 }}>
        <a className="group-link" style={{ cursor: 'pointer' }} onClick={() => setForm({ send: null })}>
          + Log sent
        </a>
      </div>
      {form && <DocumentSendForm send={form.send} defaults={defaults} onClose={() => setForm(null)} />}
    </>
  );
}
